import { PlanNames } from '../../planNames';
export const stripePriceToPlanMap = {
    'price_1NQ7CpBps2CRxBX0O6qsfweo': PlanNames.LegacyPro, // Jack Test Account
    'price_1KvdepL2UdqYSxumlNU6VAQs': PlanNames.LegacyStandard,
    'price_1KvddkL2UdqYSxumEa7JkMgG': PlanNames.LegacyLite,
    'price_1K4b2zL2UdqYSxum68DGIToB': PlanNames.LegacyStarter,
    'price_1K7RKmL2UdqYSxumeDaoXWYl': PlanNames.LegacyUnlimited,
    'price_1KvdfZL2UdqYSxumuhBelAKJ': PlanNames.LegacyPro,
};
//# sourceMappingURL=legacy.js.map